import PropTypes from 'prop-types'
import TextField from '@mui/material/TextField'
import './NumericTextboxWithLabel.css'

const NumericTextboxWithLabel = ({ allowDecimal, allowNegative, className, hideZero, label, maxValue, minValue, name, onChange, value }) => {
    const classNames = `textbox-with-label ${className ?? ''}`

    const handleChange = event => {
        const value = event.target.value

        // Only allow numeric values
        const pattern = new RegExp(`^${allowNegative ? "-?" : ''}[0-9${allowDecimal ? "." : ''}]*$`)
        if (!value.match(pattern)) {
            console.log(`input did not match pattern: ${pattern}`)
            event.preventDefault()
            return
        }

        // Only allow within a range, if specified
        if (maxValue !== '' && value !== '' && Number(value) > maxValue) {
            console.log(`input (${value}) was greater than maxValue (${maxValue})`)
            event.preventDefault()
            return
        }
        if (minValue !== '' && value !== '' && Number(value) < minValue) {
            console.log(`input (${value}) was less than minValue (${minValue})`)
            event.preventDefault()
            return
        }

        onChange(event)
    }

    const displayValue = hideZero && Number(value) === 0 ? '' : value

    return (
        <div className={classNames}>
            {label}
            <TextField name={name} value={displayValue} variant="standard" onChange={handleChange} type="number" />
        </div>
    )
}

NumericTextboxWithLabel.propTypes = {
    allowDecimal: PropTypes.bool,
    allowNegative: PropTypes.bool,
    className: PropTypes.string,
    hideZero:  PropTypes.bool,
    label: PropTypes.string,
    maxValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    minValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

NumericTextboxWithLabel.defaultProps = {
    allowDecimal: false,
    allowNegative: false,
    hideZero: true,
    maxValue: '',
    minValue: '',
    onChange: () => {},
}

export default NumericTextboxWithLabel
